import { render, staticRenderFns } from "./attachment-offline.vue?vue&type=template&id=0d64998f&scoped=true"
import script from "./attachment-offline.vue?vue&type=script&lang=js"
export * from "./attachment-offline.vue?vue&type=script&lang=js"
import style0 from "./attachment-offline.vue?vue&type=style&index=0&id=0d64998f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d64998f",
  null
  
)

export default component.exports